import { USER_TYPE, USER_POSITION, USER_TYPE_NAV_MAPPER, BLANK_OPTION } from "/constants/common.js";
import range from 'lodash/range'
export function usePrivateImage() {
  const auth = useAuthStore();
  const route = useRoute();

  const getRouteBaseName = () => {
    return route.name?.toString().split("-")[0];
  };

  const privateImage = computed(() => {
    return (
      auth.user &&
      auth.user.userType === USER_TYPE.GUEST &&
      [
        "user-like",
        "user-download",
        "yarns",
        "yarn-id",
        "supplier-id",
      ].includes(getRouteBaseName())
    );
  });

  const blockContextMenu = (evt) => {
    if (privateImage.value) {
      evt.preventDefault();
    }
  };

  return {
    privateImage,
    blockContextMenu,
  };
}

export const useFavorites = () => {
  const userStore = useUserStore();

  const isLiked = (selectedYarnlogId) => {
    return userStore.favoriteList
      ? !userStore.favoriteList.every(
          ({ yarnlogId }) => yarnlogId !== selectedYarnlogId
        )
      : false;
  };

  return {
    isLiked,
  };
};

export const useCheckUserRole = () => {
  const authStore = useAuthStore()
  const route = useRoute()
  
  const isUserGuestOrDemo = () => {
    const user = authStore.user
    const routeName = route.name
    const isUserRoleGuest = user && user.userRole === USER_POSITION.GUEST
    const isUserRoleDemo = user && user.userRole === USER_POSITION.DEMO
    const isNotSupplier = !routeName.includes(USER_TYPE_NAV_MAPPER[USER_TYPE.SUPPLIER].name)
    return isUserRoleGuest || (isUserRoleDemo && isNotSupplier)
  }
  const isUserDemo = () => {
    const user = authStore.user
    const isUserRoleDemo = user && user.userRole === USER_POSITION.DEMO
    return isUserRoleDemo
  }
  const isUserGuest = () => {
    const user = authStore.user
    const isUserRoleGuest = user && user.userRole === USER_POSITION.GUEST
    return isUserRoleGuest
  }
  
  return {
    isUserGuestOrDemo,
    isUserDemo,
    isUserGuest
  }
}

export const useCheckUserPosition = () => {
  const userStore = useUserStore()

  const checkPosition = (allowedPosition) => {
    return !allowedPosition.includes(userStore.position)
  }

  return { checkPosition}
}

export const useDateOptions = () => {
  const currentYear = new Date().getFullYear()
  const yearOptions = [
    BLANK_OPTION,
    ...range(1920, currentYear + 1).map(year => ({
      text: year,
      value: year
    }))
  ]

  const dayOptions = [
    BLANK_OPTION,
    ...range(1, 32).map(day => ({
      text: day < 10 ? `0${day}` : `${day}`,
      value: day
    }))
  ]

  const monthOptions = [
    BLANK_OPTION,
    ...range(1, 13).map(month => ({
      text: month < 10 ? `0${month}` : `${month}`,
      value: month
    }))
  ]

  return { 
    yearOptions,
    dayOptions,
    monthOptions,
  }
}

export const useClipBoard = () => {
  const copyToClipboard = (text) => {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(text)
    } else {
      const textArea = document.createElement("textarea")
      textArea.value = text
      textArea.style.position = "fixed"
      textArea.style.opacity = "0"
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        return document.execCommand("copy")
      } catch (err) {
        console.error("Failed to copy: ", err)
      } finally {
        document.body.removeChild(textArea)
      }
    }
  }

  const clearClipboard = async () => {
    if (navigator?.clipboard) {
      try {
        await navigator.clipboard.writeText('')
        return true
      } catch (err) {
        console.error('Clipboard clear failed', err)
        return false
      }
    }
    return false
  }

  return { copyToClipboard, clearClipboard }
}
